import { render, staticRenderFns } from "./AttachedFilesList.vue?vue&type=template&id=4a1d4dc0&scoped=true&"
import script from "./AttachedFilesList.vue?vue&type=script&lang=js&"
export * from "./AttachedFilesList.vue?vue&type=script&lang=js&"
import style0 from "./AttachedFilesList.vue?vue&type=style&index=0&id=4a1d4dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d4dc0",
  null
  
)

export default component.exports